export const environment = {
  production: false,
  envName: 'qa',
  baseFixUrl: 'https://marketing-qa.fixdigitalcrm.com/',
  baseUrl: 'https://marketing-qa.fixdigitalcrm.com/api/crm/webapp/v1/',
  baseUrlV1: "https://marketing-qa.fixdigitalcrm.com/api/crm/webapp/v1/",
  baseUrlV2: "https://marketing-qa.fixdigitalcrm.com/api/crm/webapp/v2/",
  version: "2.5.8"
};
